module.exports = __webpack_public_path__ + "static/media/Holly Matthews.1249d553.png";